import Flickity from 'flickity';
import imagesLoaded from 'imagesloaded';

let proto = Flickity.prototype;

/*
 * Flickity imagesLoaded v2.0.0
 * enables imagesLoaded option for Flickity
 */

Flickity.createMethods.push('_createImagesLoaded');

proto._createImagesLoaded = function() {
    this.on('activate', this.imagesLoaded);
};

proto.imagesLoaded = function() {
    if (!this.options.imagesLoaded) {
        return;
    }
    let _this = this;
    function onImagesLoadedProgress(instance, image) {
        let cell = _this.getParentCell(image.img);
        _this.cellSizeChange(cell && cell.element);
        if (!_this.options.freeScroll) {
            _this.positionSliderAtSelected();
        }
    }
    imagesLoaded(this.slider).on('progress', onImagesLoadedProgress);
};

export default Flickity;
